import { render, staticRenderFns } from "./my_patient.vue?vue&type=template&id=2a8cdf72"
import script from "./my_patient.vue?vue&type=script&lang=js"
export * from "./my_patient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports